import React from 'react';

import FileViewer from './FileViewerComponent';

import styles from '../styles/SideModal.module.css';

import IconContainer from './IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';
import { ReactComponent as ExpandIcon } from '../icons/arrows-out-simple.svg';
import { ReactComponent as ContractIcon } from '../icons/arrows-in-simple.svg';

const FileViewerModal = ({ closeModal, id, fileName }) => {
    const [isFullScreen, setIsFullScreen] = React.useState(false);

    return (
        <div className={styles.screen} onClick={closeModal}>
            <div className={styles.modalPanel} style={{maxWidth: isFullScreen ? 'none': ''}} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        Просмотр файла
                    </h1>
                    <div style={{display: 'flex', gap: '15px'}}>
                        {isFullScreen ? 
                        <IconContainer Icon={ContractIcon} onClick={() => {setIsFullScreen(!isFullScreen)}} label={'Уменьшить'} size = '20' color = 'black' className = '' />
                        :
                        <IconContainer Icon={ExpandIcon} onClick={() => {setIsFullScreen(!isFullScreen)}} label={'Расширить'} size = '20' color = 'black' className = '' />}
                        <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                    </div>
                </div>
                <div className={styles.main}>
                    <FileViewer id={id} fileName={fileName} />
                </div>
            </div>
        </div>
    )
}

export default FileViewerModal;